import { useEffect, useState } from "react";
import { useAuthChecker } from "../Context";
import { UserRoles } from "../Constant";

export const usePagePermission = (feature: string , allowedRoles: UserRoles[] ) => {
  const {
    isAuthenticated,
    checkUserPermission,
    isLoading: authLoading,
    user
  } = useAuthChecker();
  const [hasPermission, setHasPermission] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!authLoading) {
      const allowed =
        isAuthenticated &&
        checkUserPermission(feature) &&
        allowedRoles.includes(user?.userRole);
      setHasPermission(allowed);
      setIsLoading(false);
    }
  }, [authLoading, feature, isAuthenticated, allowedRoles, user?.userRole]);

  return { isLoading, hasPermission };
};
